(() => {
  function initializeDolobitesStep4V3() {
    const booking = document.querySelector('.db-booking');

    if (!booking || booking.dataset.step4V3Initialized === 'true') {
      return;
    }

    const guestRange = booking.querySelector('#db-guest-range-v3');
    const guestCount = booking.querySelector('#db-guest-count-v3');
    const recommendedPans = booking.querySelector(
      '#db-recommended-pans-v3'
    );
    const panGrid = booking.querySelector('#db-pan-grid-v3');
    const panMessage = booking.querySelector('#db-pan-message-v3');

    if (
      !guestRange ||
      !guestCount ||
      !recommendedPans ||
      !panGrid
    ) {
      return;
    }

    booking.dataset.step4V3Initialized = 'true';

    const panOptions = [
      {
        pans: 2,
        name: 'Classic Experience',
        flavours: 2,
        price: 549
      },
      {
        pans: 3,
        name: 'Classic Plus Experience',
        flavours: 3,
        price: 714
      },
      {
        pans: 4,
        name: 'Celebration Experience',
        flavours: 4,
        price: 879
      },
      {
        pans: 5,
        name: 'Celebration Plus Experience',
        flavours: 5,
        price: 1004
      },
      {
        pans: 6,
        name: 'Signature Experience',
        flavours: 6,
        price: 1129
      }
    ];

    const state = {
      guests: 0,
      recommendedPans: 0,
      selectedPans: null
    };

    const formatCurrency = (amount) =>
      new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
      }).format(amount);

    const calculateRecommendedPans = (guests) => {
      return Math.min(6, Math.max(2, Math.ceil(guests / 22)));
    };

    const updateSliderColour = () => {
      const minimum = Number(guestRange.min);
      const maximum = Number(guestRange.max);
      const current = Number(guestRange.value);

      const percentage =
        ((current - minimum) / (maximum - minimum)) * 100;

      guestRange.style.background = `
        linear-gradient(
          to right,
          #e06a24 0%,
          #e06a24 ${percentage}%,
          rgba(224, 106, 36, 0.2) ${percentage}%,
          rgba(224, 106, 36, 0.2) 100%
        )
      `;
    };

    const selectPanOption = (option) => {
      state.selectedPans = option.pans;

      panGrid
        .querySelectorAll('.db-booking__pan-card')
        .forEach((card) => {
          const selected =
            Number(card.dataset.pans) === option.pans;

          card.classList.toggle('is-selected', selected);
          card.setAttribute('aria-pressed', String(selected));
        });

      if (panMessage) {
        panMessage.textContent =
          `${option.pans} gelato pans selected · ` +
          `${option.flavours} flavours included · ` +
          `2 HOURS OF LIVE GELATO SERVICE INCLUDED`;
      }

      const flavourLimit = booking.querySelector(
        '#db-flavour-limit'
      );

      if (flavourLimit) {
        flavourLimit.textContent = option.flavours;
      }

      window.DOLOBITES_V3_SELECTION = {
        guests: state.guests,
        pans: option.pans,
        flavoursIncluded: option.flavours,
        price: option.price,
        name: option.name
      };

      document.dispatchEvent(
        new CustomEvent('dolobites:pans-change', {
          detail: window.DOLOBITES_V3_SELECTION
        })
      );
    };

    const renderPanOptions = () => {
      panGrid.innerHTML = '';

      panOptions.forEach((option) => {
        const card = document.createElement('button');

        card.type = 'button';
        card.className = 'db-booking__pan-card';
        card.dataset.pans = String(option.pans);
        card.setAttribute('aria-pressed', 'false');

        if (option.pans === state.recommendedPans) {
          card.classList.add('is-recommended');
        }

        card.innerHTML = `
          <span class="db-booking__pan-number">
            ${option.pans}
          </span>

          <span class="db-booking__pan-label">
            gelato pans
          </span>

          <span class="db-booking__pan-price">
            ${formatCurrency(option.price)}
          </span>

          <span class="db-booking__pan-flavours">
            ${option.flavours} flavours included
          </span>
        `;

        card.addEventListener('click', () => {
          selectPanOption(option);
        });

        panGrid.appendChild(card);
      });

      // Nessuna esperienza selezionata all'avvio.
// Verrà selezionata solo dopo il click del cliente.
    };

    const updateGuests = () => {
      state.guests = Number(guestRange.value);
      state.recommendedPans =
        calculateRecommendedPans(state.guests);

      guestCount.textContent = state.guests;
      recommendedPans.textContent = state.recommendedPans;

      updateSliderColour();
      renderPanOptions();
    };

    guestRange.addEventListener('input', updateGuests);
    guestRange.addEventListener('change', updateGuests);

    updateGuests();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeDolobitesStep4V3
    );
  } else {
    initializeDolobitesStep4V3();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeDolobitesStep4V3
  );
})();